var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.isAdmin == 'false')?_c('div',[_c('unionDataCenter')],1):_vm._e(),(_vm.isAdmin == 'true' )?_c('div',[_c('adminDataCenter')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }